import { Action } from '@ngrx/store';

export enum CalendarLivePollingActionTypes {
  StartCalendarPolling = '[Live] StartDealCalendar',
  StopCalendarPolling = '[Live] StopDealCalendar'
}

export class CalendarLivePollingStart implements Action {
  public readonly type = CalendarLivePollingActionTypes.StartCalendarPolling;
}

export class CalendarLivePollingStop implements Action {
  public readonly type = CalendarLivePollingActionTypes.StopCalendarPolling;
}
